import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {NgbAccordionModule} from '@ng-bootstrap/ng-bootstrap';

import {NoteBoxModule} from '../../search/note-box/note-box.module';
import {ProfileRatingModule} from '../profile-rating/profile-rating.module';
import {HeaderModule} from '../../shared/header/header.module';
import {FooterModule} from '../../shared/footer/footer.module';
import {StreamFollowedModule} from '../../streams/stream-followed/stream-followed.module';
import {ProfileCommentModule} from '../../user/profile-comment/profile-comment.module';

import {PublicProfileComponent} from './public-profile.component';

import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faSync} from '@fortawesome/free-solid-svg-icons';
import { NoteViewModule } from '../../shared/note-view/note-view.module';
import { StreamViewModule } from '../../shared/stream-view/stream-view.module';
import { ImgLazyLoadingModule } from '../../shared/image-lazy-loading/image-lazy-loading.module';
import { ShareModule } from '../../shared/share/share.module';

@NgModule({
    declarations: [
        PublicProfileComponent
    ],
    imports: [
        RouterModule.forChild([{ path: '', component: PublicProfileComponent }]),
        CommonModule,
        ProfileRatingModule,
        HeaderModule,
        FooterModule,
        NgbAccordionModule,
        ProfileCommentModule,
        StreamFollowedModule,
        NoteBoxModule,
        FontAwesomeModule,
        NoteViewModule,
        StreamViewModule,
        ImgLazyLoadingModule,
        ShareModule
    ],
    exports: [ PublicProfileComponent ]
})

export class PublicProfileModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(faSync);
  }
}
